<template>
  <div class="tablelist">
    <div class="row align--center">
      <div class="flex xs12 md4">
        <va-input :value="term" placeholder="Buscar por Id Banner" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md2">
        <va-select
          v-model="StatusOptionsModel"
          textBy="description"
          placeholder="Estado"
          :options="this.StatusOptions"
          @change="search"
        />
      </div>
      <div class="flex xs12 md3 offset--md3">
        <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
    <div>
    </div>
      <template slot="telefono" slot-scope="props">
        <div v-for="(item) in props.rowData.information" :key="item.id">
          <div v-if="item.idContactType === 2">{{item.desContactInformation}}</div>
        </div>
      </template>
      <template slot="status" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" alt="Activo" title="Activo" v-if="props.rowData.staStatus === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" alt="Inactivo" title="Inactivo" v-else/>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'edit'">
            <img class="imgdata ma-0" :id="props.rowData.idBanner" src="../../assets/images/edit.png" alt="Editar Usuario" title="Editar Usuario" width="20"  @click="dataUser(props.rowData, item.action)"/>
          </template>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data () {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['4', '6', '10', '20'],
      StatusOptions: [
        {
          id: 1,
          description: 'Activo',
        },
        {
          id: 2,
          description: 'Inactivo',
        },
      ],
      StatusOptionsModel: '',
      users: this.InfoView,
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      if (((!this.term) || (this.term.length < 1)) && (!this.StatusOptionsModel.id)) {
        return this.users
      }
      return this.users.filter(item => {
        if (this.term && this.term.length >= 1) {
          return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
        } else {
          return item
        }
      }).filter(item => {
        switch (this.StatusOptionsModel.id) {
          case 1:
            return item.staStatus === true
          case 2:
            return item.staStatus === false
          default:
            return item
        }
      })
    },
  },
  methods: {
    dataUser (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
</style>
